import type { DestinationContext, TrackingDestination } from '../types'

declare global {
  interface Window {
    _kmq?: any[]
    _kmk?: string
  }
}

function ensureQueue() {
  if (typeof window === 'undefined') return
  window._kmq = window._kmq || []
}

function loadScript(src: string) {
  if (typeof document === 'undefined') return
  const existing = document.querySelector(`script[src="${src}"]`)
  if (existing) return
  const s = document.createElement('script')
  s.async = true
  s.src = src
  document.head.appendChild(s)
}

export class KissmetricsDestination implements TrackingDestination {
  public readonly key = 'kissmetrics' as const
  public readonly requiredConsent = 'statistics' as const

  private apiKey: string | null = null
  private initialized = false

  init(ctx: DestinationContext) {
    // Repo standard: keep this env var name (do not introduce alternates).
    this.apiKey = process.env.NEXT_PUBLIC_KISSMETRICS_TRACKING_ID || null
    if (!this.apiKey) return

    // Only load Kissmetrics when consent allows (statistics)
    if (!ctx.consent.statistics) return

    ensureQueue()
    if (this.initialized) return
    this.initialized = true

    // Kissmetrics processes queued events after load; it's safe to record immediately after consent is granted.
    window._kmk = window._kmk || this.apiKey
    loadScript('//i.kissmetrics.io/i.js')
    loadScript(`//scripts.kissmetrics.io/${this.apiKey}.2.js`)
  }

  identify(userId: string) {
    if (typeof window === 'undefined') return
    ensureQueue()
    window._kmq!.push(['identify', userId])
  }

  track(eventName: string, properties?: Record<string, any>) {
    if (typeof window === 'undefined') return
    ensureQueue()
    window._kmq!.push(['record', eventName, properties || {}])
  }
}


